export enum ModalId {
  Account,
  Activation,
  Availability,
  Confirm,
  EvTaxCredit,
  FeaturesAndSpecs,
  FinanceActivation,
  GeoLocation,
  KeyFeatures,
  LockTimer,
  MoreDetails,
  NotifyMe,
  Partner,
  Petition,
  PreOrder,
  Reservable,
  ReservableCancel,
  ReservableNotification,
  ReturnPolicy,
  ShareNotification,
  SimilarVehicles
}

export const ModalPriorities = {
  [ModalId.Account]: 3,
  [ModalId.Activation]: 3,
  [ModalId.FinanceActivation]: 3,
  [ModalId.Availability]: 2,
  [ModalId.LockTimer]: 1
};

export enum NativeModalId {
  CancelReservation = 'cancel-reservation',
  Geolocation = 'geolocation',
  ReturnPolicy = 'seven-day-return-policy'
}
